<!--集团荣誉-->
<template>
    <div class="panel-container">
        <div class="list">
            <div
                class="list-item"
                v-for="(item,index) in honorList"
                :key="index"
                @click="handleClick(item.page)"
                title="查看详情"
                :data-flag="item.page"
            >
                <div class="image" v-if="item.image">
                    <img :src="item.image" alt="" style="height: 100%;width: 100%;">
                </div>
                <div class="info">
                    <div class="label">{{ item.label }}</div>
                    <p :class="item.image ? 'text' : 'auto-text'" v-html="item.text"></p>
                    <div class="bottom">
                        <div class="tags">
                            <div class="tag" v-for="(tag,_index) in item.tags" :key="_index">
                                {{ tag }}
                            </div>
                        </div>
                        <div class="clock">
                            <i class="iconfont iconfontriqi"></i>
                            &nbsp;
                            <span>{{ item.time }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {list} from './groupHonorData'

export default {
    name: 'groupHonor',
    data() {
        return {
            honorList: list,

        }
    },
    mounted() {

    },
    methods: {
        handleClick(file) {
            this.$emit('checkDetail', file)
        }
    }
}
</script>

<style lang="scss" scoped>
.panel-container {
    height: 100%;

    .list {
        margin: 0 auto;
        width: 100%;
        min-height: 800px;

        .list-item {
            cursor: pointer;
            display: flex;
            padding: 16px 16px 40px 16px;
            border-bottom: 1px solid #DCDCDC;
            margin-bottom: 40px;
            transition: all .3s ease-in-out;

            &:hover {
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

            }

            .image {
                height: 180px;
                width: 280px;
            }

            .info {
                width: calc(100% - 200px);
                padding-left: 20px;

                .label {
                    font-size: 24px;
                }

                .text {
                    margin-top: 30px;
                    font-size: 16px;
                    text-align: justify;
                    text-indent: 2em;
                    line-height: 24px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                .auto-text {
                    margin-top: 30px;
                    font-size: 16px;
                    text-align: justify;
                    text-indent: 2em;
                    line-height: 24px;
                }

                .bottom {
                    .tags {
                        margin-top: 16px;
                        display: flex;

                        .tag {
                            margin-right: 10px;
                            padding: 6px 10px;
                            background: rgba(0, 121, 254, 0.1);
                            border-radius: 4px;
                            font-size: 14px;
                            color: #0079FE;

                        }
                    }

                    .clock {
                        color: #999999;
                        margin-top: 27px;
                        text-align: right;
                    }
                }


            }
        }
    }
}

@import "../itemStyle";
</style>
